/**
 * PrintInstructions
 * Shows a dismissible banner reminding the user how to remove browser
 * headers/footers (date, URL, page number) from the printed output.
 * These are added by the browser itself and cannot be removed via CSS.
 */
export default function PrintInstructions() {
    return (
        <div
            className="no-print"
            style={{
                background: '#fffbeb',
                border: '1px solid #f59e0b',
                borderRadius: 8,
                padding: '0.7rem 1rem',
                marginBottom: '0.85rem',
                fontSize: 12.5,
                color: '#78350f',
                lineHeight: 1.6,
            }}
        >
            <strong>⚠️ Before printing — remove browser headers &amp; footers</strong>
            <br />
            The browser automatically adds the page title, URL and page numbers to every
            printout. To remove them:
            <ul style={{ paddingLeft: '1.2rem', marginTop: '4px' }}>
                <li><strong>Chrome / Edge:</strong> Print dialog → <em>More settings</em> → uncheck <em>Headers and footers</em></li>
                <li><strong>Firefox:</strong> Print dialog → <em>More settings</em> → uncheck <em>Print headers and footers</em></li>
                <li><strong>Safari:</strong> Print dialog → uncheck <em>Print headers and footers</em></li>
            </ul>
            Also set <strong>Margins → None</strong> to ensure text aligns correctly on the paper.
        </div>
    );
}